module.exports = __webpack_public_path__ + "img/202408_08.466ed140.jpg";